























import { DateUtils } from "../../utils/DateUtils";
import Week = DateUtils.Week;
import moment from "moment";

export default {
    name: "WeekSelector",
    props: {
        value: Week,
    },
    data() {
        return {
            year: moment().year(),
            week: moment().week(),
            selectedDate: null,
        };
    },
    watch: {
        year: {
            immediate: true,
            handler: function () {
                this.$emit("input", { year: this.year, week: this.week });
            },
        },
        week: {
            immediate: true,
            handler: function () {
                this.$emit("input", { year: this.year, week: this.week });
            },
        },
        selectedDate: function () {
            let date = moment(this.selectedDate);
            if (date.isValid()) {
                this.week = date.week();
                this.year = date.year();
            }
        },
    },
};
